import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function TheCaseForInclusion() {
  return <section data-section-id="224144" id="the-paperwork-problem" className="dark bg-background text-foreground py-20 md:py-32 px-6">
      <div className="max-w-[800px] mx-auto flex flex-col gap-8">
        <div className="space-y-6">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-primary">
            Your kitchen table shouldn't be your office.
          </h2>
          <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
            Farming is about being out in the pasture, not buried under a mountain of receipts and scribbled notes. We know the chaos of tracking breeding records on the back of a feed bag and losing tax-ready expenses in the glovebox of the truck.
          </p>
        </div>
        <Separator className="my-4 opacity-50 border-border" />
        <blockquote className="border-l-4 border-secondary pl-6 md:pl-8 py-2 my-4">
          <p className="font-serif text-2xl md:text-3xl font-semibold leading-snug text-secondary italic">
            "I know I wrote that down somewhere."
          </p>
        </blockquote>
        <Separator className="my-4 opacity-50 border-border" />
        <div className="space-y-6">
          <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
            BarnDesk puts every record — animals, tasks, receipts, equipment, inventory — on your phone and your computer. One place instead of seven.
          </p>
          <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
            Stop spending your evenings squinting at faded receipts. Get the day back.
          </p>
        </div>
        <div className="pt-8">
          <Link to="/FeaturesPage" className="inline-flex items-center gap-1.5 text-base text-primary hover:underline font-medium">
            See what's inside
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>;
}